import jscookie from 'js-cookie'
import { AUTH_COOKIE } from '../modules/user'
import { AUTH_API_COOKIE } from '../modules/user'

const state = {
	searchTitle: null,
	searchSubtitle: null,
	searchExportText: "",
	searchResults: null,
	searchSort: null,
	loading: null,
}

const mutations = {
	setSearchResults(state, payload) {
		state.searchResults = payload
	},
	setSearchTitle(state, payload) {
		state.searchTitle = payload
	},
	setSearchSubtitle(state, payload) {
		state.searchSubtitle = payload
	},
	setSearchExportText(state, payload) {
		state.searchExportText = payload
	},
	setSearchSort(state, payload) {
		state.searchSort = payload
	},
	setLoading(state,payload) {
		state.loading = payload
	},
	unSetLoading(state,payload) {
		state.loading = null
	},
	clearSearch(state, payload) {
		state.searchResults = null
		state.searchTitle = null
		state.searchSubtitle = null
		state.searchSort = null
		state.searchExportText = ""
		state.loading = null
	},
}

const actions = {
	fetchDept ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
			//console.log("Action: fetchDept " + payload)
				return new Promise((resolve, reject) => {
					fetch('https://api.ba.arizona.edu/if/search/dept/' + payload, {      
				      headers: {
				            'database' : getters.getDatabase(),
				            'apiEsriToken' : apiEsriToken,
				            'content-type': 'application/json',
				            'impersonate' : getters.impersonateID,
				      }})
				      .then(response => response.json())
				      .then(data => {
				      	resolve(data)
				      })
				      .catch(e => {
				        console.log(e);
				        reject()
				        return e
				      })
			    })
	},

	fetchCollege ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
			//console.log("Action: fetchDept " + payload)
				return new Promise((resolve, reject) => {
					fetch('https://api.ba.arizona.edu/if/search/collegedept/' + payload, {      
				      headers: {
				            'database' : getters.getDatabase(),
				            'apiEsriToken' : apiEsriToken,
				            'content-type': 'application/json',
				            'impersonate' : getters.impersonateID,
				      }})
				      .then(response => response.json())
				      .then(data => {
				      	resolve(data)
				      })
				      .catch(e => {
				        console.log(e);
				        reject()
				        return e
				      })
			    })
	},

	fetchPI ({commit, getters}, payload) {
			const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
			//console.log("Action: fetchPI " + payload)
				return new Promise((resolve, reject) => {
					fetch('https://api.ba.arizona.edu/if/search/PI/' + payload, {      
				      headers: {
				      		'database' : getters.getDatabase(),
				            'apiEsriToken' : apiEsriToken,
				            'content-type': 'application/json',
				            'impersonate' : getters.impersonateID,
				      }})
				      .then(response => response.json())
				      .then(data => {
				      	resolve(data)
				      })
				      .catch(e => {
				        console.log(e);
				        reject()
				        return e
				      })
			    })
	},

	fetchOccupant ({commit, getters}, payload) {
			const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
			console.log("Action: fetchOccupant " + payload)
				return new Promise((resolve, reject) => {
					fetch('https://api.ba.arizona.edu/if/search/occupant/' + payload, {      
				      headers: {
				      		'database' : getters.getDatabase(),
				            'apiEsriToken' : apiEsriToken,
				            'content-type': 'application/json',
				            'impersonate' : getters.impersonateID,
				      }})
				      .then(response => response.json())
				      .then(data => {
				      	resolve(data)
				      })
				      .catch(e => {
				        console.log(e);
				        reject()
				        return e
				      })
			    })
	},

	fetchRoomsByPI ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		console.log("Action: fetchRoomsByPI ")
		return new Promise((resolve, reject) => {
	  		fetch('https://api.ba.arizona.edu/if/rooms/PI/' + payload, {      
		      headers: {
		      		'database' : getters.getDatabase(),
		            'apiEsriToken' : apiEsriToken,
		            'content-type': 'application/json',
		            'impersonate' : getters.impersonateID,
		      }})
		      .then(response => response.json())
		      .then(data => {	
		        resolve(data)
		      })
		      .catch(e => {
		        console.log(e);
		        reject(error) 
		    })
		})
	},

	fetchSearchRooms ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		console.log("Action: fetchRoomSearch ")
		return new Promise((resolve, reject) => {
	  		fetch('https://api.ba.arizona.edu/if/search/rooms', {      
			    headers: {
			      		'database' : getters.getDatabase(),
			            'apiEsriToken' : apiEsriToken,
			            'content-type': 'application/json',
			            'impersonate' : getters.impersonateID, 
			        	},
		                method: "POST",
		                body: JSON.stringify(payload)
            })
		    .then(response => response.json())
		    .then(data => {	
		    	resolve(data)
		    })
		    .catch(e => {
		    	console.log(e);
		    	reject(error)
		    })
		})
	},

	fetchSearchRoomsMultiAttribute ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		console.log("Action: fetchRoomSearch ")
		return new Promise((resolve, reject) => {
	  		fetch('https://api.ba.arizona.edu/if/search/roomsMultiAttribute', {      
			    headers: {
			      		'database' : getters.getDatabase(),
			            'apiEsriToken' : apiEsriToken,
			            'content-type': 'application/json',
			            'impersonate' : getters.impersonateID, 
			        	},
		                method: "POST",
		                body: JSON.stringify(payload)
            })
		    .then(response => response.json())
		    .then(data => {	
		    	resolve(data)
		    })
		    .catch(e => {
		    	console.log(e);
		    	reject(error)
		    })
		})
	},

	fetchSearchRoomAmenities ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		console.log("Action: fetchRoomAmenitiesSearch ")
		return new Promise((resolve, reject) => {
	  		fetch('https://api.ba.arizona.edu/if/search/roomAmenities', {      
			    headers: {
			      		'database' : getters.getDatabase(),
			            'apiEsriToken' : apiEsriToken,
			            'content-type': 'application/json',
			            'impersonate' : getters.impersonateID, 
			        	},
		                method: "POST",
		                body: JSON.stringify(payload)
            })
		    .then(response => response.json())
		    .then(data => {	
		    	resolve(data)
		    })
		    .catch(e => {
		    	console.log(e);
		    	reject(error)
		    })
		})
	},


}

export default {
	state,
	//getters,
	actions,
	mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/search.js